import { downloadFile } from "../../mobile/mobileHandler";

export async function Save(base64, inApp, fileName = ""){

    const chunkSize = 10000; // Adjust chunk size if needed
    const totalChunks = Math.ceil(base64.length / chunkSize);

    for (let i = 0; i < totalChunks; i++) {
        const chunk = base64.slice(i * chunkSize, (i + 1) * chunkSize);
        downloadFile(chunk, i === totalChunks - 1, fileName);//send to application
        const perc = ((1 +(i / totalChunks - 1))*100).toFixed("2");
        console.log(perc + "%");

        await sleep(1);//wait for the app to catch up... annoying
    }
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}